import { isArray, isObject } from 'lodash';
import { updateObject } from './../../utils/utility';

const initialState = {
    orderList: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listRefreshed: false,
    countryList: [],
    companyList: [],
    legalEntityList: [],
    AFNarratives: {},
    serviceTypes: []
};

const setDirectCustomerOrderList = (state = initialState, action) => {
    const { orderList, totalOrder, pageNumber, totalPages, countryList, companyList, legalEntityList, serviceTypes } = action.data;
    return updateObject(state, {
        orderList,
        totalElements: totalOrder,
        pageNumber,
        totalPages,
        listRefreshed: true,
        countryList,
        companyList,
        legalEntityList,
        serviceTypes
    });
};

const setFinancialDirectCustomerOrderList = (state = initialState, action) => {
    const { orderList, totalOrder, pageNumber, totalPages, countryList, companyList, legalEntityList } = action.data;
    return updateObject(state, {
        orderList,
        totalElements: totalOrder,
        pageNumber,
        totalPages,
        listRefreshed: true,
        countryList,
        companyList,
        legalEntityList
    });
};

const resetAFNarratives = (state = initialState) => {
    return updateObject(state, {
        AFNarratives: {}
    });
}

const setAFNarratives = (state = initialState, action) => {
    let narratives = {};
    if (isArray(action.data)) {
        action.data.map((narrative) => {
            if (!state.AFNarratives.hasOwnProperty(narrative)) {
                narratives[narrative] = false;
            }
        })
        return updateObject(state, {
            AFNarratives: { ...state.AFNarratives, ...narratives }
        });
    }
    if (isObject(action.data)) {
        for (const key in action.data) {
            if (!state.AFNarratives.hasOwnProperty(key)) {
                narratives[key] = action.data[key];
            }
        }
        return updateObject(state, {
            AFNarratives: { ...state.AFNarratives, ...action.data }
        });
    }
}

const updateSpecificOrderData = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { orderList } = state;
    orderList[rowIndex] = { ...orderList[rowIndex], [columnName]: value };
    return updateObject(state, { orderList });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_DIRECT_CUSTOMER_ORDER_LIST") {
        return setDirectCustomerOrderList(state, action);
    }
    if (action.type === "SET_FINANCIAL_DIRECT_CUSTOMER_ORDER_LIST") {
        return setFinancialDirectCustomerOrderList(state, action);
    }
    if (action.type === "RESET_AF_NARRATIVES") {
        return resetAFNarratives(state);
    }
    if (action.type === "SET_AF_NARRATIVES") {
        return setAFNarratives(state, action);
    }
    if (action.type === "UPDATE_NARRATIVES") {
        const { key, value } = action;
        return updateObject(state, { AFNarratives: { ...state.AFNarratives, [key]: value } });
    }
    else if (action.type === "UPDATE_SPECIFIC_ORDER_DATA") {
        return updateSpecificOrderData(state, action);
    }
    return state;
}

export default reducer;